import { Dimensions } from "./Dimensions";
import { Direction } from "./Direction";

export class GridLocation {
  constructor(public row: number, public col: number) {}

  toHash(): GridLocationHash {
    return (this.row + "." + this.col) as GridLocationHash;
  }

  toGridIndex(dimensions: Dimensions): number {
    return this.row * dimensions.width + this.col;
  }

  isInDimensions(dimensions: Dimensions) {
    return (
      this.row >= 0 &&
      this.row < dimensions.height &&
      this.col >= 0 &&
      this.col < dimensions.width
    );
  }

  addDirection(direction: Direction) {
    switch (direction) {
      case "up":
        return new GridLocation(this.row - 1, this.col);
      case "down":
        return new GridLocation(this.row + 1, this.col);
      case "left":
        return new GridLocation(this.row, this.col - 1);
      case "right":
        return new GridLocation(this.row, this.col + 1);
    }
  }

  static fromGridIndex(index: number, dimensions: Dimensions): GridLocation {
    return new GridLocation(
      Math.floor(index / dimensions.height),
      Math.floor(index % dimensions.width)
    );
  }

  static fromHash(hash: GridLocationHash): GridLocation {
    const [row, col] = hash.split(".");
    return new GridLocation(parseInt(row), parseInt(col));
  }
}
declare const gridLocationHash: unique symbol;
export type GridLocationHash = string & { readonly [gridLocationHash]: true };
